/**
 * Size-aware quantity mins for Corporate hub (corporate-charcuterie-newport-beach).
 * Petite Cups=25 | Premium Cups=15 | Mini Boxes 5x5=15
 */
(function () {
  const SIZE_MINS = {
    'Petite Cups': 25,
    'Premium Cups': 15,
    'Mini Boxes 5x5': 15,
  };

  function isCorporateHub(url) {
    return (
      url.includes('/products/corporate-charcuterie-newport-beach') ||
      url.includes('/products/shape-charcuterie-board')
    );
  }

  function applySizeMin() {
    const productInfo = document.querySelector('product-info');
    if (!productInfo) return;
    const url = productInfo.dataset.url || '';
    if (!isCorporateHub(url)) return;

    const input = productInfo.querySelector('.quantity__input');
    if (!input) return;

    let size = null;
    const checked = productInfo.querySelector('input[type="radio"][name^="Size"]:checked, fieldset input[type="radio"]:checked');
    if (checked) {
      size = checked.value;
    } else {
      const selects = productInfo.querySelectorAll('variant-selects select, select');
      for (const s of selects) {
        const label = s.getAttribute('name') || s.previousElementSibling?.textContent || '';
        if (/size/i.test(label) || s.closest('fieldset')?.querySelector('legend')?.textContent?.match(/size/i)) {
          size = s.value;
          break;
        }
      }
      if (!size) {
        const firstChecked = productInfo.querySelector('variant-selects input[type="radio"]:checked');
        if (firstChecked) size = firstChecked.value;
      }
    }

    if (!size || !(size in SIZE_MINS)) {
      const selectedOpt = productInfo.querySelector('.product-form__input--pill input:checked, .product-form__input input:checked');
      if (selectedOpt) size = selectedOpt.value;
    }

    if (!size || !(size in SIZE_MINS)) return;
    const min = SIZE_MINS[size];
    input.setAttribute('data-min', String(min));
    input.min = String(min);
    const val = parseInt(input.value, 10) || 0;
    if (val < min) input.value = String(min);
  }

  document.addEventListener('DOMContentLoaded', applySizeMin);
  document.addEventListener('change', function (e) {
    if (e.target && (e.target.matches('input[type="radio"]') || e.target.matches('select'))) {
      setTimeout(applySizeMin, 50);
      setTimeout(applySizeMin, 400);
    }
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    try {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(applySizeMin, 50);
      });
    } catch (e) {}
  }
})();


/* Dockside totals include all its variants. Companion food is tagged in Admin. */
(function () {
  function updateDocksideMinimum() {
    const info = document.querySelector('product-info[data-url*="/products/dockside-charcuterie-board-6min"]');
    if (!info) return;
    const rule = info.querySelector('[data-dockside-rule]');
    const input = info.querySelector('.quantity__input');
    if (!rule || !input) return;
    let required = Number(rule.dataset.required);
    let inCart = Number(rule.dataset.inCart);
    const cartRoot = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
    if (cartRoot) {
      const lines = Array.from(cartRoot.querySelectorAll('input[name="updates[]"][data-oc-dockside]'));
      required = lines.some(line => line.dataset.ocFoodCompanion === 'true') ? 6 : 12;
      inCart = lines.reduce((sum, line) => sum + (line.dataset.ocDockside === 'true' ? Number(line.getAttribute('value')) || 0 : 0), 0);
    }
    const remaining = Math.max(1, required - inCart);
    input.min = String(remaining);
    input.dataset.min = String(remaining);
    if ((Number(input.value) || 0) < remaining) input.value = String(remaining);
    const minimumLabel = info.querySelector('[data-dockside-min-label]');
    if (minimumLabel && /Minimum of/.test(minimumLabel.textContent)) minimumLabel.textContent = 'Minimum of ' + remaining;
    const currency = rule.dataset.currency || 'USD';
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency}).format(cents / 100);
    const unitPrice = Number(rule.dataset.unitPrice);
    rule.textContent = 'Minimum food subtotal before delivery: ' + money(unitPrice * required) + ' ' + currency + ' (' + required + ' × ' + money(unitPrice) + ').';
  }
  function scheduleDocksideMinimum() {
    setTimeout(updateDocksideMinimum, 50);
    setTimeout(updateDocksideMinimum, 450);
  }
  document.addEventListener('DOMContentLoaded', scheduleDocksideMinimum);
  document.addEventListener('change', event => {
    if (event.target.closest('product-info[data-url*="/products/dockside-charcuterie-board-6min"]')) scheduleDocksideMinimum();
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleDocksideMinimum);
    subscribe(PUB_SUB_EVENTS.variantChange, scheduleDocksideMinimum);
  }
})();
